import { PARTNER_PRESETS, PartnerPreset } from "./registry";

/*
* Detects which partner settings to apply, based on the URL.
* Is used before login.
*
* HappyAds is the default — there is no ViaAds distributor today.
*/

export function detectPartnerFromHost(host: string = window.location.host): PartnerPreset {
  if (host.includes("via")) {
    return PARTNER_PRESETS.viaads;
  }
  return PARTNER_PRESETS.happyads;
}
